<template>
  <div class="sp-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/program/header-img.png" />
      <div class="header-title">Programmes</div>
    </div>
    <div class="page-content">
      <div class="content-text">
        <div class="title">Introductions</div>
        <div class="text">
          Flagship Programmes initiated and co-organized by WFUCA and its members.
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="Program Name">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Program Date">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="Program Location">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-link type="primary" @click="handleSearch()">Search</el-link>
          </el-form-item>
        </el-form>
      </div>
      <el-row :gutter="20" class="program-list">
        <el-col :span="6" v-for="(item, index) in list" :key="index">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" :src="item.img" />
            </div>
            <div class="item-title" @click="$goDetail(item.id, 'programs')">
              {{ item.name }}
            </div>
          </div>
        </el-col>
        <!-- <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img
                class="item-img"
                src="@/assets/images/program/list-item.png"
              />
            </div>
            <div class="item-title">The Co-Creation, an</div>
          </div>
        </el-col> -->
      </el-row>

      <div class="more-text" v-if="list.length < listQuery.total" @click="handleListMore">
        View More
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      formInline: {},
      listQuery: {
        pageNum: 1,
        pageSize: 8,
        total: 0,
      },
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$get(this.$api + "/un/webprogram/list", {
        ...this.formInline,
        ...this.listQuery,
      }).then((res) => {
        this.list = res.rows;
      });
    },
    handleListMore() {
      this.listQuery.pageNum += 1;
      this.getList();
    },
    handleSearch() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 8,
        total: 0,
      };
      this.getList();
    },
    handleClick: () => {},
  },
};
</script>
<style scoped lang="scss">
.mobile {
  .title {
    font-size: 20px !important;
    line-height: 20px !important;
    .text {
      font-size: 14px !important;
      margin: 14px 0 !important;
      line-height: 22px !important;
    }
  }
  .sp-page {
    .page-content {
      .more-text {
        width: 60vw !important;
        font-size: 16px !important;
        line-height: 20px !important;
        margin: 20px auto !important;
      }
      .program-list {
        .list-item {
          height: max-content !important;
        }
        .el-col {
          width: 100% !important;
        }
      }
      ::v-deep .el-form {
        width: 100%;
        padding: 20px 10px !important;
        .el-link--inner {
          width: 50vw;
          background-color: #00a0e1;
          padding: 2px 0 !important;
          color: #fff;
          border-radius: 30px !important;
          text-align: center;
          margin-left: 25vw !important;
        }
        .el-link.el-link--primary:hover::after {
          display: none !important;
        }
        .el-form-item {
          width: 100%;
          .el-form-item__content {
            width: calc(100% - 70px) !important;
          }
          .el-input__inner {
            width: 100% !important;
          }
        }
      }
    }
  }
}
.sp-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  .page-content {
    padding: fh(60vh, pc) fw(200vw, pc);
    .more-text {
      margin: fh(60vh, pc) auto;
      font-size: fh(18vh, pc);
      color: #0077d4;
      width: max-content;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    .program-list {
      .list-item {
        padding-top: fh(20vh, pc);
        margin-bottom: fh(50vh, pc);
        margin-bottom: fh(20vh, pc);
        border-top: 1px solid #e4e4e4;
        height: fh(380vh, pc);
        overflow: hidden;
        .img-view {
          position: relative;
          width: 100%;
          height: fh(222vh, pc);
          overflow: hidden;
          img {
            position: absolute;
            width: 100%;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .item-title {
          margin: fh(20vh, pc) 0;
          font-size: fh(24vh, pc);
          line-height: fh(29vh, pc);
          color: #333;
          font-weight: bold;
          display: -webkit-box; /* 使用弹性盒模型布局 */
          -webkit-line-clamp: 4; /*显示的行数*/
          -webkit-box-orient: vertical; /* 垂直方向排列*/
          overflow: hidden;
          text-overflow: ellipsis; /* 超出部分显示省略号*/
          &:hover {
            cursor: pointer;
            color: #000;
          }
        }
      }
    }
    .content-text {
      .title {
        font-size: fh(36vh, pc);
        line-height: fh(54vh, pc);
        color: #333;
        font-weight: bold;
      }
      .text {
        font-size: fh(18vh, pc);
        line-height: fh(28vh, pc);
        color: #2a2a2a;
      }
    }
    ::v-deep .el-form {
      padding-top: fh(40vh, pc);
      padding-bottom: fh(40vh, pc);
      .el-form-item {
        margin-right: fw(20vw, pc);
        .el-input__inner {
          width: fw(288vw, pc);
          border-radius: 50px;
        }
      }
    }
  }
}
</style>
